import { Image } from "antd";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useChart from "../../api/mutations/homepageChart";
import { useGetFAQ } from "../../api/queries/faq.quesries";
import { CustomButton } from "../../components/CustomButton";
import CustomSelect from "../../components/CustomSelect";
import { CustomSpinner } from "../../components/CustomSpinner";
import FAQSection from "../../components/FAQSection";
import { StaticChart } from "../../components/StaticChart";
import {
  CHART_ERROR_MSG,
  EMOTIONAL_INTELLIGENCE,
  EMOTIONAL_STRATEGY_SECTION,
  GRAPH_SECTION,
  INFORMATION_SECTION,
  SECTION_ONE_CONTENT,
  SELECT_OPTIONS,
  TESTIMONIALS_SECTION,
} from "./HomePage.const";

import SECOND_IMAGE from "../../assets/emotional-intelligence.svg";
import EQ_IMAGE from "../../assets/emotinelStrategy.svg";
import BRAIN from "../../assets/brain.svg";
import FIRST_IMAGE from "../../assets/main-photo.svg";
import FIFTH_BLOCK_CIRCLE_IMAGE from "../../assets/top-fifth-circle.svg";
import FOURTH_BLOCK_CIRCLE_IMAGE from "../../assets/top-fourth-circle.svg";
import FIRST_BLOCK_CIRCLE_IMAGE from "../../assets/top-second-circle.svg";
import SEVENTH_BLOCK_CIRCLE_IMAGE from "../../assets/top-seventh-cirle.svg";
import SIXTH_BLOCK_CIRCLE_IMAGE from "../../assets/top-sixth-cirle.svg";
import THIRD_BLOCK_CIRCLE_IMAGE from "../../assets/top-third-circle.svg";
import useTestMutation from "../../api/mutations/testMutation";
import GoogleTag from "../../components/GoogleTag";

type ChartExplanationItem = {
  reason: string;
  percent: number;
};

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { data: faqs } = useGetFAQ();

  const { getHomeChartExplanation } = useChart();

  const [eqValue, setEqValue] = useState(80);
  const [timeValue, setTimeValue] = useState("1 Månad");
  const [period, setPeriod] = useState(1);
  const [periodValue, setPeriodValue] = useState("month");
  const [chartExplanation, setChartExplanation] = useState<
    ChartExplanationItem[]
  >([]);

  const [isLoadingChartData, setLoadingChartData] = useState(false);
  const [isSpinnerVisible, setSpinnerVisible] = useState(false);
  const [erorChart, setErrorChart] = useState("");

  const imageRef = useRef<HTMLImageElement>(null);
  const imageRef2 = useRef<HTMLImageElement>(null);
  const imageRef3 = useRef<HTMLImageElement>(null);
  const imageRef4 = useRef<HTMLImageElement>(null);
  const imageRef5 = useRef<HTMLImageElement>(null);
  const imageRef6 = useRef<HTMLImageElement>(null);
  const referenceElementRef = useRef<HTMLDivElement>(null);
  const referenceElementRef2 = useRef<HTMLParagraphElement>(null);
  const referenceElementRef3 = useRef<HTMLParagraphElement>(null);
  const referenceElementRef4 = useRef<HTMLDivElement>(null);
  const referenceElementRef5 = useRef<HTMLParagraphElement>(null);
  const referenceElementRef6 = useRef<HTMLDivElement>(null);
  const referenceElementRefEmotionalEQSection = useRef<HTMLDivElement>(null);

  const handleEqChange = (selectedOption: any) => {
    setEqValue(Number(selectedOption.value));
  };

  const handleButtonClick = () => {
    navigate("/checkout");
  };

  const handlePeriodChange = (selectedOption: any) => {
    setTimeValue(selectedOption.value);
    switch (selectedOption.value) {
      case "1 Månad":
        setPeriod(1);
        setPeriodValue("month");
        break;
      case "1 År":
        setPeriod(1);
        setPeriodValue("year");
        break;
      case "5 År":
        setPeriod(5);
        setPeriodValue("year");
        break;
      default:
        setPeriod(1);
        setPeriodValue("month");
    }
  };

  const { getStaticPdf } = useTestMutation();
  useEffect(() => {
    const setPosition = () => {
      if (imageRef.current && referenceElementRef.current) {
        const referenceElementPosition =
          referenceElementRef.current.getBoundingClientRect();
        const newTopPosition = referenceElementPosition.top + window.scrollY;

        imageRef.current.style.position = "absolute";
        imageRef.current.style.top = `${newTopPosition}px`;
        imageRef.current.style.right = `0px`;
      }

      if (imageRef2.current && referenceElementRef2.current) {
        const referenceElementPosition =
          referenceElementRef2.current.getBoundingClientRect();
        const newTopPosition = referenceElementPosition.top + window.scrollY;

        imageRef2.current.style.position = "absolute";
        imageRef2.current.style.top = `${newTopPosition}px`;
        imageRef2.current.style.left = `0px`;
      }

      if (imageRef3.current && referenceElementRef3.current) {
        const referenceElementPosition =
          referenceElementRef3.current.getBoundingClientRect();
        const newTopPosition = referenceElementPosition.top + window.scrollY;

        imageRef3.current.style.position = "absolute";
        imageRef3.current.style.top = `${newTopPosition}px`;
        imageRef3.current.style.right = `0px`;
      }

      if (imageRef4.current && referenceElementRef4.current) {
        const referenceElementPosition =
          referenceElementRef4.current.getBoundingClientRect();
        const newTopPosition = referenceElementPosition.top + window.scrollY;

        imageRef4.current.style.position = "absolute";
        imageRef4.current.style.top = `${newTopPosition}px`;
        imageRef4.current.style.left = `0px`;
      }

      if (imageRef5.current && referenceElementRef5.current) {
        const referenceElementPosition =
          referenceElementRef5.current.getBoundingClientRect();
        const newTopPosition = referenceElementPosition.top + window.scrollY;

        imageRef5.current.style.position = "absolute";
        imageRef5.current.style.top = `${newTopPosition}px`;
        imageRef5.current.style.right = `0px`;
      }
    };

    setPosition();
    window.addEventListener("resize", setPosition);

    return () => window.removeEventListener("resize", setPosition);
  }, []);

  useEffect(() => {
    const setPosition = () => {
      if (imageRef6.current && referenceElementRef6.current) {
        const referenceElementPosition =
          referenceElementRef6.current.getBoundingClientRect();
        const newTopPosition = referenceElementPosition.top + window.scrollY;

        imageRef6.current.style.position = "absolute";
        imageRef6.current.style.top = `${newTopPosition}px`;
        imageRef6.current.style.left = `0px`;
      }
    };

    setPosition();
    window.addEventListener("resize", setPosition);

    return () => window.removeEventListener("resize", setPosition);
  }, [faqs]);

  useEffect(() => {
    if (eqValue && periodValue && period) {
      setLoadingChartData(true);
      setSpinnerVisible(true);

      const timerPromise = new Promise<void>((resolve) => {
        setTimeout(resolve, 500);
      });

      const requestPromise = getHomeChartExplanation.trigger({
        type: "eq",
        value: eqValue,
        period,
        periodValue,
      });

      Promise.all([timerPromise, requestPromise])
        .then(([_, res]) => {
          const chartData = res.data?.data || [];
          setChartExplanation(chartData);
          setErrorChart("");
        })
        .catch(() => {
          setErrorChart(CHART_ERROR_MSG);
          toast.error(CHART_ERROR_MSG, {
            style: {
              backgroundColor: "#3F51B5",
            },
          });
        })
        .finally(() => {
          setLoadingChartData(false);
          setSpinnerVisible(false);
        });
    }
  }, [eqValue, periodValue, period]);

  const downloadPdf = async () => {
    try {
      const pdfBlob = await getStaticPdf.trigger();
      const url = window.URL.createObjectURL(new Blob([pdfBlob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Så funkar EQ.pdf");
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (error) {
      console.error("Error downloading PDF:", error);
      toast.error("Failed to download the document.");
    }
  };

  return (
    <main className="flex-grow h-full flex items-center justify-center">
      <GoogleTag />
      <div className="flex flex-col justify-center items-center">
        <div className="max-w-[1260px] p-3 flex flex-col gap-[60px]">
          {
            // FIRST BLOCK
          }
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full h-full bg-primary-card rounded-lg">
            <div className="w-full h-full flex justify-center">
              <Image
                src={FIRST_IMAGE}
                alt="Main photo"
                className="rounded-t-lg md:rounded-t-none lg:rounded-l-lg object-cover lg:w-[612px] lg:h-[612px]"
                preview={false}
              />
            </div>
            <div className="flex flex-col items-start lg:pt-12 pr-9 pb-12 pl-5 lg:pl-0 gap-8 text-start">
              <h1
                className="text-white text-4xl md:text-5xl font-normal break-words font-nunito"
                style={{ lineHeight: 1.3 }}
              >
                {SECTION_ONE_CONTENT.HEADER}
              </h1>

              <h5 className="text-white text-2xl font-nunito leading-snug">
                {SECTION_ONE_CONTENT.DESCRIPTION}
              </h5>

              <div className="flex flex-col gap-4 w-full justify-center md:justify-start">
                <div
                  ref={referenceElementRef}
                  className="flex flex-col-reverse md:flex-row gap-3"
                >
                  <CustomButton
                    customStyles={"h-[56px] w-full md:max-w-[200px]"}
                    onClick={downloadPdf}
                    btnType="secondary"
                    disabled={getStaticPdf?.isMutating}
                  >
                    {SECTION_ONE_CONTENT.BUTTONS.SECONDARY}
                  </CustomButton>
                  <CustomButton
                    customStyles={"h-[56px] w-full md:max-w-[300px]"}
                    onClick={handleButtonClick}
                  >
                    {SECTION_ONE_CONTENT.BUTTONS.PRIMARY}
                  </CustomButton>
                </div>
              </div>
            </div>
          </div>

          {
            // SECOND BLOCK
          }
          <div
            className="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full h-full bg-primary-card rounded-lg"
            ref={referenceElementRefEmotionalEQSection}
          >
            <div className="flex flex-col items-start lg:pt-10 pl-9 pb-9 pr-5 lg:pr-0 gap-6 order-2 lg:order-1">
              <div className="flex flex-col gap-2 text-start">
                <h1 className="text-white text-4xl md:text-[40px] font-normal break-words font-nunito leading-normal">
                  {EMOTIONAL_INTELLIGENCE.HEADER}
                </h1>
                <h5 className="text-white text-3xl font-nunito">
                  {EMOTIONAL_INTELLIGENCE.SUBHEADER}
                </h5>
              </div>
              <div className="flex flex-col gap-3 text-start">
                <p className="text-white text-base font-nunito">
                  {EMOTIONAL_INTELLIGENCE.DESCRIPTIONS.PRIMARY}
                </p>
                <p className="text-white text-base font-nunito">
                  {EMOTIONAL_INTELLIGENCE.DESCRIPTIONS.SECONDARY}
                </p>
                <p
                  className="text-white text-base font-nunito"
                  ref={referenceElementRef2}
                >
                  {EMOTIONAL_INTELLIGENCE.DESCRIPTIONS.SUPPORTING}
                </p>
                <ul className="list-disc list-outside text-white text-base font-nunito">
                  {EMOTIONAL_INTELLIGENCE.LIST_ITEMS?.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
                <p className="text-white text-base font-nunito">
                  {EMOTIONAL_INTELLIGENCE.DESCRIPTIONS.CONCLUSION}
                </p>
              </div>
            </div>
            <div className="w-full h-full flex justify-center order-1 lg:order-2">
              <Image
                src={SECOND_IMAGE}
                alt="main-photo"
                className="rounded-t-lg md:rounded-t-none lg:rounded-r-lg object-cover"
                preview={false}
              />
            </div>
          </div>

          {
            // THIRD BLOCK
          }
          {
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full h-full bg-primary-card rounded-lg">
              <div className="flex flex-col items-start lg:pt-10 pl-9 pb-9 pr-5 lg:pr-0 gap-6 order-2 lg:order-1">
                <div className="flex flex-col gap-2 text-start">
                  <h1
                    className="text-white text-3xl md:text-[40px] font-semibold break-words font-nunito leading-normal"
                    style={{ lineHeight: 1.5 }}
                  >
                    {EMOTIONAL_STRATEGY_SECTION.HEADING}
                  </h1>
                </div>
                <div className="flex flex-col gap-2 text-start">
                  <h2 className="text-white text-2xl md:text-[28px] font-normal break-words font-nunito leading-normal">
                    {EMOTIONAL_STRATEGY_SECTION.HEADING_Emotinel}
                  </h2>
                  <h2 className="text-white font-normal break-words font-nunito leading-normal">
                    {EMOTIONAL_STRATEGY_SECTION.SUB_HEADING_1}
                  </h2>
                </div>
                <div className="flex flex-col gap-3 text-start">
                  <h2 className="text-white font-normal break-words font-nunito leading-normal">
                    {EMOTIONAL_STRATEGY_SECTION.SUB_HEADING_1_1}
                  </h2>
                  <ul className="list-none text-white text-base font-quicksand">
                    {EMOTIONAL_STRATEGY_SECTION.LIST_ITEMS_DASHED.map(
                      (item, index) => (
                        <li key={index} className="mb-2">
                          - {item}
                        </li>
                      )
                    )}
                  </ul>
                </div>
                <div className="flex flex-col gap-2 text-start">
                  <h2 className="text-white text-2xl md:text-[28px] font-normal break-words font-nunito leading-normal">
                    {EMOTIONAL_STRATEGY_SECTION.SUB_HEADING_2}
                  </h2>
                </div>
                <div className="flex flex-col gap-3 text-start">
                  <ul className="list-none text-white text-base font-quicksand">
                    {EMOTIONAL_STRATEGY_SECTION.LIST_ITEMS_NUMBERED.map(
                      (item, index) => (
                        <li key={index} className="mb-4">
                          {item}
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </div>
              <div className="w-full h-full flex justify-center order-1 lg:order-2">
                <div ref={referenceElementRef3}></div>
                <Image
                  src={EQ_IMAGE}
                  alt="Emotional Intelligence"
                  className="rounded-t-lg md:rounded-t-none object-cover"
                  preview={false}
                />
              </div>
            </div>
          }
          {
            // FOURH SECTION
          }
          <div className="flex flex-col gap-8 w-full h-full bg-primary-card rounded-lg px-5 md:px-5 pt-9 pb-4 lg:pt-12 md:pl-9 lg:pb-12 md:pr-5 lg:pr-0">
            <div className="flex flex-col gap-2">
              <h1 className="text-white text-2xl md:text-3xl lg:text-[40px] font-normal break-words font-nunito leading-normal text-start">
                {GRAPH_SECTION.HEADER}
              </h1>
            </div>
            <div className="flex flex-col lg:flex-row gap-8 w-full h-full">
              <div className="flex flex-col">
                <p className="text-white font-quicksand text-[22px] font-normal text-start mb-3">
                  {"Ett exempel"}
                </p>
                <div className="lg:min-w-[360px]">
                  <StaticChart />
                </div>
                <div className="flex justify-between gap-3 w-full mt-5">
                  <CustomSelect
                    title={
                      "EQ variation mellan individer. Låg EQ är 80 och hög EQ är 140."
                    }
                    options={SELECT_OPTIONS.EQ}
                    label={"EQ"}
                    onChange={handleEqChange}
                    placement="bottomRight"
                  />
                  <CustomSelect
                    title={
                      "Reaktionsmönstret varierar i med tiden och rummet där du tar dina beslut. Därfär har vi exempel på hur en individ med 80 respektive 140 i EQ tänker/känner vid utvecklingar på +-10% respektive +-20% under 1 månad, 1 år och 5 år."
                    }
                    options={SELECT_OPTIONS.TIME}
                    label={"Tid"}
                    onChange={handlePeriodChange}
                    placement="bottom"
                  />
                </div>
              </div>
              <div className="w-full h-full flex flex-col justify-center gap-6 text-start px-3 lg:pr-9 pb-12 md:pl-5 lg:pl-0">
                <div className="flex justify-center">
                  <div className="flex justify-between gap-4">
                    <h5 className="text-white text-xl md:text-3xl font-nunito text-center">
                      {GRAPH_SECTION.EQ140}
                      {eqValue}
                    </h5>
                    <h5 className="text-white text-xl md:text-3xl font-nunito text-center">
                      {GRAPH_SECTION.TIME}
                      {timeValue}
                    </h5>
                  </div>
                </div>
                <div
                  className={classNames(
                    "sm:min-h-[550px] lg:min-h-[500px] relative",
                    {
                      "sm:min-h-[100px] lg:min-h-[100px]": !!erorChart,
                    }
                  )}
                >
                  {(isLoadingChartData || isSpinnerVisible) && (
                    <CustomSpinner />
                  )}
                  {chartExplanation.length > 0 && (
                    <ul
                      className={`list-none space-y-6 mt-4 ${
                        isLoadingChartData ? "opacity-30" : ""
                      }`}
                    >
                      {chartExplanation.map((item, index) => (
                        <li key={index} className="flex items-center">
                          <div
                            className="w-[40px] h-[40px] p-3 flex items-center justify-center text-white rounded-lg mr-4"
                            style={{
                              backgroundColor:
                                item.percent === 20
                                  ? "#2E8260"
                                  : item.percent === 10
                                  ? "#34A16E"
                                  : item.percent === -10
                                  ? "#B5493F"
                                  : item.percent === -20
                                  ? "#8F403C"
                                  : "#3F51B5", // default color if no match
                            }}
                          >
                            <p className="text-white font-quicksand text-[13px] font-normal leading-[24px]">
                              {item.percent > 0 ? "+" : ""}
                              {item.percent}%
                            </p>
                          </div>
                          <p className="text-white font-quicksand text-[16px] font-normal leading-[24px]">
                            {item.reason}
                          </p>
                        </li>
                      ))}
                    </ul>
                  )}
                  {erorChart && (
                    <div
                      className={`w-full h-full flex items-start justify-center ${
                        isLoadingChartData ? "opacity-30" : ""
                      }`}
                    >
                      <p className="text-white font-nunito text-[28px] font-normal leading-[24px] text-center">
                        {erorChart}
                      </p>
                    </div>
                  )}
                </div>

                <div className="flex flex-col-reverse md:flex-row gap-5">
                  <CustomButton
                    customStyles={"h-[56px] w-full md:max-w-[330px]"}
                    onClick={downloadPdf}
                    btnType="secondary"
                  >
                    {GRAPH_SECTION.BUTTON_TEXT_SECONDARY}
                  </CustomButton>
                  <CustomButton
                    customStyles={"h-[56px] w-full md:max-w-[330px]"}
                    onClick={handleButtonClick}
                  >
                    {GRAPH_SECTION.BUTTON_TEXT_PRIMARY}
                  </CustomButton>
                </div>
              </div>
            </div>
          </div>

          {
            // FIFTH SECTION
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full h-full bg-primary-card rounded-lg">
              <div className="flex flex-col items-start lg:pt-10 pr-9 pb-9 pl-5 lg:pl-0 gap-6 order-2 lg:order-2">
                <div className="flex flex-col gap-2 text-start">
                  <h1 className="text-white text-3xl md:text-4xl font-normal break-words font-nunito leading-normal">
                    {INFORMATION_SECTION.HEADING}
                  </h1>
                </div>
                <div className="flex flex-col gap-3 text-start">
                  <p className="text-white text-base font-nunito">
                    {INFORMATION_SECTION.PARAGRAPHS.FIRST}
                  </p>
                  <ol className="list-decimal pl-5 text-white text-base font-quicksand">
                    {INFORMATION_SECTION.LIST_ITEMS.map((item, index) => (
                      <li key={index} className="mb-4">
                        {item}
                      </li>
                    ))}
                  </ol>
                  <p
                    className="text-white text-base font-nunito"
                    ref={referenceElementRef5}
                  >
                    {INFORMATION_SECTION.PARAGRAPHS.SECOND}
                  </p>
                </div>
              </div>
              <div className="w-full h-full flex justify-center order-1 lg:order-1">
                <div ref={referenceElementRef4}></div>
                <Image
                  src={BRAIN}
                  alt="Emotional Intelligence"
                  className="rounded-t-lg md:rounded-t-none lg:rounded-l-lg object-cover"
                  preview={false}
                />
              </div>
            </div>
          }

          {
            // SIXTH SECTION
          }

          <div className="w-full h-full bg-primary-card rounded-lg p-8 text-start">
            <h2 className="text-white text-4xl md:text-5xl font-nunito font-semibold mb-8">
              {TESTIMONIALS_SECTION.TITLE}
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
              {TESTIMONIALS_SECTION.FEEDBACKS.map((testimonial, index) => (
                <div key={index} className="flex flex-col gap-4">
                  <h4 className="text-white text-3xl font-nunito">
                    {testimonial.NAME}
                  </h4>
                  <p className="text-white text-xl font-quicksand">
                    {testimonial.ROLE}
                  </p>
                  <p className="text-white text-base font-quicksand">
                    {testimonial.TEXT}
                  </p>
                </div>
              ))}
            </div>
            <div className="flex justify-center items-center mt-8">
              <CustomButton
                customStyles={"h-[56px] w-full md:max-w-[330px]"}
                onClick={handleButtonClick}
              >
                {TESTIMONIALS_SECTION.BUTTON_TEXT}
              </CustomButton>
            </div>
          </div>
          {
            // FAQ SECTION
          }

          {faqs && (
            <div className="w-full h-full" ref={referenceElementRef6}>
              <FAQSection data={faqs} />
            </div>
          )}

          {
            // IMAGES CIRCLES
          }
          <div className="w-full h-full flex justify-center">
            <img
              ref={imageRef}
              src={FIRST_BLOCK_CIRCLE_IMAGE}
              alt="main-photo"
              className="object-cover w-[230] h-[230px] md:w-[400] md:h-[400px] -z-10"
            />
            <img
              ref={imageRef2}
              src={THIRD_BLOCK_CIRCLE_IMAGE}
              alt="main-photo"
              className="w-[230] h-[230px] md:w-[700] md:h-[700px] lg:w-[870px] lg:h-[870px] -z-10"
            />

            <img
              ref={imageRef3}
              src={FOURTH_BLOCK_CIRCLE_IMAGE}
              alt="main-photo"
              className="w-[230] h-[230px] md:w-[700] md:h-[700px] lg:w-[870px] lg:h-[870px] -z-10"
            />

            <img
              ref={imageRef4}
              src={FIFTH_BLOCK_CIRCLE_IMAGE}
              alt="main-photo"
              className="w-[230] h-[230px] md:w-[400px] md:h-[400px] -z-10"
            />

            <img
              ref={imageRef5}
              src={SIXTH_BLOCK_CIRCLE_IMAGE}
              alt="main-photo"
              className="w-[230] h-[230px] md:w-[600px] md:h-[600px] -z-10"
            />

            {faqs && (
              <img
                ref={imageRef6}
                src={SEVENTH_BLOCK_CIRCLE_IMAGE}
                alt="main-photo"
                className="w-[230] h-[230px] md:w-[600px] md:h-[600px] -z-10"
              />
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default HomePage;
